export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7415.7894b128.jpg";